<template>
  <div class="esim-devicecheck">
    <slot name="txtHeadline"></slot>
    <div class="devicecheck-content">
      <div class="form-row">
            <fieldset tabindex="-1" id="fieldset_deviceType">
            <InputAutocomplete
              :input-id="'deviceType'"
              :clear-input-id="'deviceType-clear-input'"
              :label="getSlotText('lblDeviceType')"
              :data='deviceTypes'
              :placeholder="getSlotText('txtPlaceholderDeviceType')"
              :listAriaLabel="getSlotText('txtAriaLabelListDeviceType','Liste')"
              :inputAriaLabel="getSlotText('ariaLabelDeviceType')"
              object-key-name="value"
              @selectedItemChange="deviceTypeChange($event)"
              :disabled=false
              :read-only=true
              :default-icon="'arrow'"
              :hard-filter=false
              :show-success-icon=false
              :pointer=true
              :with-focus=true
              :focus-icon="''"
              :focus-next="'#fieldset_manufacturer'"
            />
          </fieldset>
          <fieldset tabindex="-1" id="fieldset_manufacturer">
            <InputAutocomplete
              :input-id="'manufacturer'"
              :clear-input-id="'manufacturer-clear-input'"
              :label="getSlotText('lblManufacturer')"
              :data='sortedManufacturerList'
              :placeholder="getSlotText('txtPlaceholderManufacturer')"
              :listAriaLabel="getSlotText('txtAriaLabelListManufacturer','Liste')"
              :inputAriaLabel="getSlotText('ariaLabelManufacturer')"
              object-key-name="value"
              @selectedItemChange="manufacturerChange($event)"
              :disabled=false
              :read-only=true
              :default-icon="'arrow'"
              :hard-filter=false
              :show-success-icon=false
              :pointer=true
              :with-focus=true
              :focus-icon="''"
              :focus-next="'#fieldset_deviceSearch'"
            />
          </fieldset>
      </div>
      <div class="form-row">
        <fieldset tabindex="-1" id="fieldset_deviceSearch" class="device-search-field no-valid-check-sign">
          <InputAutocomplete
            :input-id="'deviceSearch'"
            :clear-input-id="'device-clear-input'"
            :label="getSlotText('lblDevice')"
            :data='filteredSortedDeviceGroups'
            :placeholder="getSlotText('txtPlaceholderDeviceSearch')"
            :listAriaLabel="getSlotText('txtAriaLabelListDeviceSearch','Liste')"
            :inputAriaLabel="getSlotText('ariaLabelDevice')"
            object-key-name="name"
            @selectedItemChange="deviceChange($event)"
            :disabled=false
            :hard-filter=false
            :not-found-input-msg="'Keine Ergebnisse'"
            ref="deviceInput"
            :focus-next="'.fluid-mobile'"
          />
          <div aria-live="polite">
            <!--            show until check found your device-->
            <div class="devicecheck-description" v-if="!isValidDeviceSelected"><slot name="info"></slot></div>
            <!--            show Only if Check found your device-->
            <div class="devicecheck-description" v-else><slot name="infoSuccess"></slot></div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex'
import InputAutocomplete from '@/components/generic/InputAutocomplete.vue'

export default {
  name: 'ESimDevicecheck',
  components: {
    InputAutocomplete
  },
  mixins: [
  ],
  data () {
    return {
      initialized: false,
      formData: {
        deviceType: null,
        manufacturer: null,
        device: ''
      },
      showItemised: true,
      deviceTypes: []
    }
  },
  props: { },
  created () {
    this.initialize()
    if (this.storedDeviceGroupsLoadingStatus === 'ERROR' || this.storedDeviceGroupsLoadingStatus === 'INVALID') {
      const data = {
        type: 'technical',
        message: 'Technischer Fehler beim Laden der Gerätedaten'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('error', data)
      }
    }
  },
  mounted () {
    this.initialized = false
    this.showItemised = this.storedDeviceCheckItemized
    this.formData.deviceType = null
    this.formData.manufacturer = null
    this.formData.device = ''
    this.initialized = true
  },
  computed: {
    ...mapGetters('deviceData', {
      storedDeviceGroups: 'deviceGroups',
      storedDeviceGroupsLoadingStatus: 'deviceGroupsLoadingStatus',
      storedDeviceManufacturers: 'deviceManufacturers',
      storedDeviceTypes: 'deviceTypes',
      storedDeviceCheckItemized: 'deviceCheckItemized'
    }),
    sortedManufacturerList: function () {
      return this.storedDeviceManufacturers.map(function (item) {
        return {
          key: item.manufacturer,
          value: item.manufacturer
        }
      }).sort((a, b) => {
        const na = a.value.toLowerCase()
        const nb = b.value.toLowerCase()
        if (na < nb) return -1
        if (na > nb) return 1
        return 0
      })
    },
    sortedDeviceGroups: function () {
      const deviceGroups = this.storedDeviceGroups // create copy to sort prefetched list
      return deviceGroups.sort((a, b) => {
        const na = a.name.toLowerCase()
        const nb = b.name.toLowerCase()
        if (na < nb) return -1
        if (na > nb) return 1
        return 0
      })
    },
    filteredSortedDeviceGroups () {
      return this.sortedDeviceGroups.filter((deviceItem) => { return deviceItem.supports && deviceItem.supports.eSim })
        .filter((deviceItem) => { return (!this.formData.manufacturer || deviceItem.manufacturer === this.formData.manufacturer) })
        .filter((deviceItem) => { return (!this.formData.deviceType || deviceItem.deviceType === this.formData.deviceType) })
        .filter((deviceItem) => { return (`${deviceItem.name}`.toLowerCase().indexOf(this.formData.device.toLowerCase()) >= 0) })
    },
    isValidDeviceSelected () {
      let valid = false
      if (this.formData.device && this.filteredSortedDeviceGroups.length) {
        valid = this.filteredSortedDeviceGroups.filter((deviceItem) => { return (deviceItem.name.toLowerCase() === this.formData.device.toLowerCase()) }).length === 1
      }
      return valid
    },
    availableDeviceTypes () {
      if (this.getSlotText('txtDeviceTypeLabelConfig') !== '') {
        return this.getSlotText('txtDeviceTypeLabelConfig')
      }
      return '{}'
    }
  },
  methods: {
    ...mapActions('deviceData', [
      'getDeviceGroupList'
    ]),
    ...mapMutations('deviceData', [
      'storeDeviceCheckItemized'
    ]),
    async initialize () {
      await this.getDeviceGroupList()
      this.deviceTypes = this.prepareDeviceTypes()
    },
    deviceTypeChange (e) {
      e = e === '' ? e : this.deviceTypes.find(type => type.value === e).key
      this.formData.deviceType = e
      this.triggerFilterTracking('deviceType', e)
      this.formData.device = ''
      this.$refs.deviceInput.resetAutocompleteInputField()
    },
    manufacturerChange (e) {
      this.formData.manufacturer = e
      this.triggerFilterTracking('manufacturer', e)
      this.formData.device = ''
      this.$refs.deviceInput.resetAutocompleteInputField()
    },
    deviceChange (e) {
      this.formData.device = e
      this.triggerFilterTracking('device', e)
    },
    prepareDeviceTypes () {
      let deviceTypeOptions = null
      let optionsValid = false
      try {
        deviceTypeOptions = JSON.parse(this.availableDeviceTypes)
        if (deviceTypeOptions && typeof deviceTypeOptions === 'object') {
          // check devicetype options: key with magma value is uppercase and displayname is not empty
          const optionKeys = Object.keys(deviceTypeOptions)
          optionsValid = (optionKeys.length === optionKeys.filter((key) => {
            if (key.toUpperCase() === key && typeof deviceTypeOptions[key] === 'string' && deviceTypeOptions[key] !== '') {
              return true
            } else {
              const data = {
                type: 'technical',
                message: 'Ungültiger Gerätetyp: ' + deviceTypeOptions[key]
              }
              if (typeof window.trackingNS?.track?.tracking === 'function') {
                window.trackingNS.track.tracking('error', data)
              }
              return false
            }
          }).length)
        }
      } catch (e) {
        const data = {
          type: 'technical',
          message: 'Fehler in den definierten Gerätetypen'
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
      }
      return this.storedDeviceTypes.map(function (item) {
        let displayName = item.deviceType[0].toUpperCase() + item.deviceType.slice(1).toLowerCase() // formated default from magma
        if (optionsValid && typeof deviceTypeOptions[item.deviceType] !== 'undefined') {
          displayName = deviceTypeOptions[item.deviceType] // from contao if defined
        }
        return {
          key: item.deviceType,
          value: displayName
        }
      }).sort((a, b) => {
        const na = a.value.toLowerCase()
        const nb = b.value.toLowerCase()
        if (na < nb) return -1
        if (na > nb) return 1
        return 0
      })
    },
    toogleShowItemized () {
      this.showItemised = !this.showItemised
      this.storeDeviceCheckItemized(this.showItemised)
    },

    triggerFilterTracking: function (fieldName, filterValue) {
      let filterName = ''
      const action = filterValue === '' ? 'remove filter' : 'add filter'
      if (fieldName === 'deviceType') {
        filterName = 'device'
      } else if (fieldName === 'manufacturer') {
        filterName = 'vendor'
      } else if (fieldName === 'device') {
        filterName = 'model'
      }
      const data = {
        action: action,
        updated_filter: [
          {
            name: filterName,
            value: filterValue
          }
        ],
        applied_filters: [
          {
            name: 'vendor',
            value: this.formData.manufacturer?.key || ''
          },
          {
            name: 'device',
            value: this.formData.deviceType?.key || ''
          },
          {
            name: 'model',
            value: this.formData.device || ''
          }
        ]
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('filter products', data)
      }
    }
  },
  mutations: {
    storeShowItemized: (state, data) => {
      state.showItemized = data
    }
  }
}
</script>
